import { DETERMINAR_PAGINA_ATUAL_CIDADE } from '../types'

export default function determinarPaginaAtualCidade (paginaAtual) {
  return {
    type: DETERMINAR_PAGINA_ATUAL_CIDADE,
    payload: paginaAtual
  }
}
